type OptionalString = string | undefined | null;
type OptionalNumber = number | undefined | null;

export const isBlank = (value: OptionalString): boolean => {
    return value === '';
};

const isEmpty = (value: OptionalString): boolean => {
    return value?.trim() === '';
};

const isNotEmpty = (value: OptionalString): boolean => {
    return !isEmpty(value);
};

export const isNotBlank = (value: OptionalString): boolean => {
    return !isBlank(value);
};

export const isValidString = (value: OptionalString): boolean => {
    return (
        value != null &&
        value != undefined &&
        isNotEmpty(value) &&
        isNotBlank(value)
    );
};

export const isYear = (value: OptionalNumber): boolean => {
    return value?.toString().length === 4;
};

export const isValidColor = (color: any) => {
    const hexRegex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
    const hexaRegex = new RegExp(/^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{3})$/);
    return hexRegex.test(color) || hexaRegex.test(color);
};

export const validHexWithoutAlpha = (color: any) => {
    const hexRegex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
    return hexRegex.test(color);
};

export const isValidNumber = (value: any): boolean => {
    return (
        value != null &&
        value != undefined &&
        !isNaN(value) &&
        isFinite(value) &&
        !isNaN(parseFloat(value.toString()))
    );
};

export const isValidEmail = (email: OptionalString): boolean => {
    if (!isValidString(email)) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email as string);
};
